<template>
  <v-layout ref="sideContent"
            :class="[$style.sideContent, getStyle]"
            column
            fill-height>
    <v-flex ref="sideHeader"
            shrink>
      <slot name="header"/>
    </v-flex>
    <v-flex :style="{maxHeight: height}"
            :class="$style.sideMain"
            grow >
      <slot name="main"/>
    </v-flex>
    <v-flex ref="sideFooter"
            shrink>
      <slot name="footer"/>
    </v-flex>
  </v-layout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

/**
 * Provide 3 slots to place content in header, main and footer containers.
 */
@Component({
  name: 'SideContent',
})
export default class SideContent extends Vue {
  height = '';

  mounted() {
    this.setMainHeight();
    this.getStyle();
    window.addEventListener('resize', this.setMainHeight);
    window.addEventListener('resize', this.getStyle);
  }

  /* Heights of the parts of the sidebar */
  getHeaderHeight() {
    if (this.$refs.sideHeader) {
      return this.$refs.sideHeader.clientHeight;
    }

    return  0;
  }
  getFooterHeight() {
    if (this.$refs.sideFooter) {
      return this.$refs.sideFooter.clientHeight;
    }

    return 0;
  }
  getContentHeight() {
    if (this.$refs.sideContent) {
      return this.$refs.sideContent.clientHeight;
    }

    return  0;
  }
  static getMinMainHeight() {
    return 200;
  }

  isThereRoom() {
    return this.getHeaderHeight() + this.getFooterHeight() +
      SideContent.getMinMainHeight() < this.getContentHeight();
  }

  /**
   * Sets the height of the middle part that should scroll independently
   */
  setMainHeight() {
    if (this.isThereRoom()) {
      this.height = `${this.getContentHeight() - (this.getHeaderHeight() + this.getFooterHeight())}px`;
    } else {
      this.height = 'none';
    }
  }

  /**
   *  If header and footer takes too much place of the page ang the main part
   *  won't fit, returns style for default behaviour
   *  */
  getStyle() {
    if (this.isThereRoom()) {
      return this.$style.scrolled;
    }

    return this.$style.fullContent;
  }
}

</script>

<style lang="scss" module>
  @import "@/style/variables.scss";

  .sideContent.scrolled {
    overflow-y: hidden;
  }
  .sideContent.fullContent {
    overflow-y: auto;
  }

  .fullContent .sideMain {
    color: red;
    max-height: none;
  }
  .sideMain {
    overflow-y: auto;
    background-color: $light-cart-bg;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/SideContent.vue